module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e2726"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e2776"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c7_r1#d7e4848",
      "id": "d14e112"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD BY ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIMON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERES ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e2826"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c8_r1#d7e60510",
      "id": "d14e123"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD BY ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IESEL ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e2876"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c9_r1#d7e86313",
      "id": "d14e134"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE TO THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITION ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e2926"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c10_r1#d7e112316",
      "id": "d14e145"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "d7e2986"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c11_r1#d7e151019",
      "id": "d14e150"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART I ")]), _vm._v("The Knife, the Fire, and the Wood")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3056"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c12_r1#d7e154920",
      "id": "d14e157"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 1  ")]), _vm._v("FIRST MEMORIES—DEVASTATION NOW")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3126"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c13_r1#d7e371936",
      "id": "d14e163"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 2  ")]), _vm._v("FAMILY MATTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3196"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c14_r1#d7e459243",
      "id": "d14e169"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 3  ")]), _vm._v("A LIFESAVING SPEECH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3266"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c15_r1#d7e615954",
      "id": "d14e175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 4  ")]), _vm._v("BUCHENWALD—THE DARK TUNNEL AND SPARKS OF LIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3366"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c16_r1#d7e932377",
      "id": "d14e181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 5 ")]), _vm._v("LIBERATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3446"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c17_r1#d7e1164994",
      "id": "d14e188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 6  ")]), _vm._v("THE VISION OF THE DRY BONES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3516"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c18_r1#d7e13735109",
      "id": "d14e194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 7  ")]), _vm._v("LANDING IN THE “PROMISED” LAND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3586"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c19_r1#d7e16411129",
      "id": "d14e200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 8  ")]), _vm._v("LEARNING TO PLAY BALL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "tocphoto"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c19_r1#chphoto",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Insert I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3656"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c20_r1#d7e19735157",
      "id": "d14e206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 9 ")]), _vm._v("PRACTICE WHAT YOU PREACH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3757"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c21_r1#d7e23065180",
      "id": "d14e212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 10  ")]), _vm._v("TORAH FOUNDATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3827"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c22_r1#d7e25379197",
      "id": "d14e218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 11  ")]), _vm._v("PILLARS OF MY PEOPLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e3897"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c23_r1#d7e29467226",
      "id": "d14e224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 12  ")]), _vm._v("MAKE ME A MATCH")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "d7e3967"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c24_r1#d7e32398247",
      "id": "d14e230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART II ")]), _c('b', [_vm._v(" The Ram’s Horn")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c25_r1#d7e32438248",
      "id": "d14e237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 13  ")]), _vm._v("REMEMBRANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4117"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c26_r1#d7e34407262",
      "id": "d14e243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 14  ")]), _vm._v("“HE GIRDS ISRAEL WITH STRENGTH”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "tocphoto12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c26_r1#chphoto12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Insert II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4207"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c27_r1#d7e37516287",
      "id": "d14e249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 15  ")]), _vm._v("WORKING AT GOOD WORKS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4277"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c28_r1#d7e40185306",
      "id": "d14e256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 16  ")]), _vm._v("YITZHAK RABIN—THE BRIDGE THAT COLLAPSED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4377"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c29_r1#d7e41412315",
      "id": "d14e262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 17  ")]), _vm._v("PAPAL PARLEY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4447"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c30_r1#d7e44186335",
      "id": "d14e268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 18  ")]), _vm._v("FOR THE SAKE OF PEACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4517"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c31_r1#d7e48129363",
      "id": "d14e274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 19  ")]), _vm._v("PREŠOV—THUS WAS THE CROWN RESTORED TO ITS ANCIENT GLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4627"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c32_r1#d7e49602373",
      "id": "d14e280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 20  ")]), _vm._v("“IN THE LANDS OF THE LIVING”")]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4717"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c33_r1#d7e52033390",
      "id": "d14e289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e4767"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_c34_r1#d7e52278392",
      "id": "d14e294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXTUAL ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITATIONS ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97d9ecc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Auth_ISBN9781402790959_epub_toc_r1.vue
// module id = 72
// module chunks = 0